import { BulkSpreadsheet, parseBool, parseNum, type BulkColumn } from '../shared/BulkSpreadsheet';
import { invoiceService } from '@kss/api';
import type { InvoiceCreate } from '@kss/api';
import { loadStoreOptions, loadUserOptions, loadSalesOrderOptions } from '../shared/formLoaders';

const columns: BulkColumn<InvoiceCreate>[] = [
  { key: 'invoiceNumber', header: 'Invoice #', required: true, sample: 'INV-1001' },
  { key: 'invoiceDate', header: 'Date', dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'dueDate', header: 'Due', dataType: 'date' },
  { key: 'customerId', header: 'Customer', dataType: 'lookup', loadOptions: loadUserOptions },
  { key: 'salesOrderId', header: 'Sales order', dataType: 'lookup', loadOptions: loadSalesOrderOptions },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'subTotal', header: 'Sub total', dataType: 'number', parse: parseNum as never },
  { key: 'discountAmount', header: 'Discount', dataType: 'number', parse: parseNum as never },
  { key: 'taxAmount', header: 'Tax', dataType: 'number', parse: parseNum as never },
  { key: 'totalAmount', header: 'Total', dataType: 'number', parse: parseNum as never, required: true, sample: '1500' },
  { key: 'paidAmount', header: 'Paid', dataType: 'number', parse: parseNum as never },
  { key: 'balanceAmount', header: 'Balance', dataType: 'number', parse: parseNum as never },
  { key: 'status', header: 'Status', sample: 'Draft' },
  { key: 'notes', header: 'Notes' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkInvoice() {
  return (
    <BulkSpreadsheet<InvoiceCreate> title="Bulk import invoices" entityLabel="invoice" backPath="/panel/invoices" columns={columns} module="Invoice"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, totalAmount: Number(r.totalAmount ?? 0), isActive: r.isActive ?? true }));
        const created = await invoiceService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
